import {createAction} from '@reduxjs/toolkit';

import type {ServerThread} from '../types/threads';

export const markThreadFollowed = createAction<ServerThread['id']>('threads/actions/markThreadFollowed');
